import React , { Component } from 'react';
import { Switch, Route, Link, withRouter } from 'react-router-dom';
import {routes} from './router.js';
import './App.css';
//引用图片
import s_icon1 from './assets/images/s_icon1.gif';
// import logoImg from './assets/images/logo.png';
import beianbgsImg from './assets/images/beianbgs.png';
// import { render } from '@testing-library/react';

class App extends Component{
	constructor(props) {
		super(props);
		this.state = {
			pathName: ''
		}
	}
	static getDerivedStateFromProps (nextProps, prevState){
		if(nextProps.location.pathname !== prevState.pathName) {
			prevState.pathName = nextProps.location.pathname;
			return prevState;
		}
		return null;
	}
	componentDidMount() {
		this.setState({
			pathName: this.props.location.pathname
		});
	}
	renderRoutes() {
		return routes.map((item) => {
			return <Route exact path={item.path} 
						component={item.component} key={item.name} 
					/>
		});
	}
	renderNavs() {
		return routes.map((item) => {
			return !item.hidden ? 
				<li className={`menu ${item.path===this.state.pathName?'active':''}`} key={item.name} >
					<Link to={item.path}>
					{item.intro}
					</Link>
				</li>
				: ''
		})
	}
	routerWillLeave(nextLocation) {
		console.log("lalala",nextLocation)
	}
	render() {
		return (
			<div className="App">
				<div className="top">
					{/* <Link to="/tip" className="links red">"创赢联盟"合作声明</Link> */}
					{/* <a href="./tip" className="links red">"创赢联盟"合作声明</a> */}
					<a href="https://www.fuiou.com" className="links green">富友集团</a>
					<span className="links grey">客服热线：95138</span>
				</div>
				<div className="menus_wrapper">
					<div className="menus">
						<ul>
							{this.renderNavs()}
						</ul>
					</div>
				</div>
					<Switch>
						{this.renderRoutes()}
					</Switch>
				<div className="footer">
					<p className="f_top"> 
						<span>© 2014-2022 上海富友电子商务有限公司版权所有  </span>
					</p>
					<p>上海市浦东新区金藏路351号 021-68619388</p>
					<p className="f_bottom">
						<a className="link" href="https://beian.miit.gov.cn/" target="_blank">沪ICP备19003978号-1</a>
						{/* <img className="link_img" src={s_icon1} alt="" /> */}
						<img className="poli_img" src={beianbgsImg} alt="" />
						<a target="_blank" rel='noreferrer noopener' href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502010173">沪公网安备  31011502010173</a>
					</p>
				</div>
			</div>
		)
	}
}
export default withRouter(App);

